'use strict';

angular.module('app.entityDashboard').controller('EntityDashboardController', EntityDashboardController);

EntityDashboardController.$inject = ['utilService', 'ModalService', 'EntityService', 'StatsService'];

function EntityDashboardController(utilService, ModalService, EntityService, StatsService) {
    var vm = this;
    vm.loggedInUser = utilService.getLoggedInUserData();
    vm.paymentFlowType = utilService.getPaymentFlowType();
    vm.spinner = {active: false};
    vm.entityDetails = {};
    vm.currentEntity = null;

    vm.getCurrentEntity = getCurrentEntity;
    vm.getEntityDetails = getEntityDetails;
    vm.disableStripeConnectPlatformAgreement = disableStripeConnectPlatformAgreement;

    getCurrentEntity();

    function getCurrentEntity() {
        EntityService.getEntitiesOfAdmin().then(function (res) {
            if (res.status === 200) {
                vm.currentEntity = res.data.entities[0];
                vm.getEntityDetails(vm.currentEntity.id);
            }
        });
    }

    function getEntityDetails(id) {
        StatsService.getEntityDetailsById(id).then(function (res) {
            if (res.status === 200) {
                res.data.data.push(res.data.total);
                vm.entityDetails = res.data.data;
            }
        });
    }

    function disableStripeConnectPlatformAgreement() {
        if (vm.currentEntity.accepted_stripe_terms) {
            vm.spinner.active = true;
            EntityService.acceptStripeTerms(vm.currentEntity.id).then(function (res) {
                vm.spinner.active = false;
                if (res.status === 200) {
                    ModalService.alert('You successfully accepted Stripe terms and conditions for entity ' + vm.loggedInUser.firstName, 'Stripe Terms and conditions');
                }
            });
        } else {
            vm.currentEntity.accepted_stripe_terms = !vm.currentEntity.accepted_stripe_terms;
        }
    }
}
